<template>
  <div class="hwh-calculator__block" :style="cssVars">
    <div class="hwh-calculator__sub">
      Total savings for a Rheem Hybrid Electric HPWH
    </div>
    <div class="hwh-calculator__row hwh-calculator__row--356 hwh-calculator__step-3">
      <div class="hwh-calculator__col hwh-calculator__col--250 hwh-calculator__col--border hwh-calculator__col--bar ">
           <div class="hwh-calculator__row hwh-calculator__row--356 hwh-calculator__chart-wrap-mob">
                <div class="hwh-calculator__col  hwh-calculator__col--250 hwh-calculator__col--border hwh-calculator__col--investment">
            <div class="hwh-calculator__header">Initial Project Investment</div>
            <div class="hwh-calculator__result">
              <div class="hwh-calculator__bar hwh-calculator__bar--electric" id="investment_Electric"
                :style="{ height: `${investmentElectricBarHeight}px` }">
                <div class="hwh-calculator__bar-label">Electric<br />Water Heater
                  <div class="hwh-calculator__bar-value">${{ electricPrice }}</div>
                </div>
              </div>
              <div class="hwh-calculator__bar hwh-calculator__bar--hybrid" id="investment_Hybrid"
                :style="{ height: `${investmentHybridBarHeight}px` }">
                <div class="hwh-calculator__bar-label">Hybrid<br />Water Heater
                  <div class="hwh-calculator__bar-value" v-if="rheemPrice > 0">{{ rheemPrice | currency }}</div>
                  <div class="hwh-calculator__bar-value" v-if="rheemPrice < 0">-{{ -rheemPrice | currency }}</div>
                </div>
              </div>
            </div>
          </div>
                   <div class="hwh-calculator__col hwh-calculator__col--250 hwh-calculator__col--annual">
            <div class="hwh-calculator__header">Annual Energy Operating Costs</div>
            <div class="hwh-calculator__result">
              <div class="hwh-calculator__bar hwh-calculator__bar--electric" id="operatingCosts_Electric"
                :style="{ height: `${annualCostElectricBarHeight}px` }">
                <div class="hwh-calculator__bar-label">Electric<br />Water Heater
                  <div class="hwh-calculator__bar-value">${{ annualCostElectric }}</div>
                </div>
              </div>
              <div class="hwh-calculator__bar hwh-calculator__bar--hybrid" id="operatingCosts_Hybrid"
                :style="{ height: `${annualCostHybridBarHeight}px` }">
                <div class="hwh-calculator__bar-label">Hybrid<br />Water Heater
                  <div class="hwh-calculator__bar-value">${{ annualCostHybrid }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
         <div class="hwh-calculator__col  hwh-calculator__col--250">
        <div class="hwh-calculator__header">Hybrid Electric Heat Pump Water Heater – Return on Investment</div>
        <div class="hwh-calculator__result hwh-calculator__result--bg">
          <div class="hwh-calculator__result-block">
            <div class="hwh-calculator__result-block-hint">
              <div class="hwh-calculator__result-block-popup">
                <div class="symbol">(</div>
                <div>Standard<br />Electric<br />AOC</div>
                <div class="symbol symbol--sm">×</div>
                <div>10yrs</div>
                <div class="symbol symbol--sm">+</div>
                <div>Initial<br />investment<br />costs</div>
                <div class="symbol">)</div>
                <div class="symbol  symbol--sm symbol--sep">–</div>
                <div class="symbol">(</div>
                <div>Hybrid<br />Electric<br />HPWH AOC</div>
                <div class="symbol symbol--sm">×</div>
                <div>10yrs</div>
                <div class="symbol symbol--sm">+</div>
                <div>Initial<br />investment<br />costs</div>
                <div class="symbol">)</div>
              </div>
              ?
            </div>
            <div class="hwh-calculator__result-block-label">Lifetime Savings:</div>
            <div class="hwh-calculator__result-block-value">{{ lifetimeROI | currency }}</div>
          </div>
          <div class="hwh-calculator__result-block">
            <div class="hwh-calculator__result-block-hint">
              <div class="hwh-calculator__result-block-popup">
                <div>Standard<br />Electric<br />AOC</div>
                <div class="symbol symbol--sm" style="margin: 0 10px;">–</div>
                <div>Hybrid<br />Electric<br />HPWH AOC</div>
              </div>
              ?
            </div>
            <div class="hwh-calculator__result-block-label">Annual Energy Operating<br />Costs Savings:</div>
            <div class="hwh-calculator__result-block-value">{{ annualCostSavings | currency(2) }}</div>
          </div>
          <div class="hwh-calculator__result-block">
            <div class="hwh-calculator__result-block-hint">
              <div class="hwh-calculator__result-block-popup">
                <div class="symbol">(</div>
                <div>Standard Electric<br />Initial investment<br />costs</div>
                <div class="symbol symbol--sm" style="margin: 0 10px;">–</div>
                <div>Hybrid Electric<br />HPWH<br />Initial investment<br />costs</div>
                <div class="symbol">)</div>
                <div class="symbol  symbol--sm">÷</div>
                <div>Annual Energy<br />Operating Costs<br />Savings</div>
                <div class="symbol symbol--sm">×</div>
                <div>12 months</div>
              </div>
              ?
            </div>
            <div class="hwh-calculator__result-block-label">Pays for Itself in:</div>
            <div class="hwh-calculator__result-block-value" v-if="paybackIsNumber">{{ paybackYears }} <span>months</span>
            </div>
            <div class="hwh-calculator__result-block-value" v-else><span>{{ paybackYears }}</span></div>
          </div>
        </div>
      </div>

    </div>
    <template>
      <div class="hwh-calculator__comment" v-if="hasFedTaxCreditWithPercentage">
        Initial Investment and Lifetime Return Savings calculations are based on project cost (product + installation
        costs) of 50-gallon models minus estimated tax credits and rebates. Estimated federal tax credit is calculated as
        {{ fedTaxCreditWithPercentageProgram.percent }}% of project cost.
        Default water heater prices do not include tax or delivery fees. Rheem is not responsible for tax and rebate
        filing.
        Consult with a tax advisor and local utility for complete filing and eligibility requirements.
      </div>
      <div class="hwh-calculator__comment" v-else>
        On average, a Rheem Hybrid Water heater pays for itself in under two years.
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import calculation from '@/utils/calculation';
import config from '@/config';

export default {
  name: 'Step3',
  props: {},
  mounted() {
    setTimeout(() => {
      this.calculateForm();
    }, 50);
  },
  data() {
    return {
      // Initial investment costs
      electricPrice: config.ELECTRIC_PRICE + config.ELECTRIC_INSTALLATION_PRICE,
      // Vars for Charts building
      maxBarHeight: 300,

      // Result vars
      annualCostSavings: null,
      paybackYears: null,
      lifetimeROI: null,
      annualCostElectric: null,
      annualCostHybrid: null,

      investmentElectricBarHeight: 0,
      investmentHybridBarHeight: 0,

      annualCostElectricBarHeight: 0,
      annualCostHybridBarHeight: 0,
    };
  },
  computed: {
    ...mapState(['hybridPrice', 'validAvgEnergyRate', 'imgDir']),
    ...mapGetters(['rheemPrice', 'hasFedTaxCreditWithPercentage', 'fedTaxCreditWithPercentageProgram']),
    paybackIsNumber() {
      return this.paybackYears !== 'a year or less';
    },
    cssVars() {
      return {
        '--investment-div-height': `calc(${+this.investmentElectricBarHeight > +this.investmentHybridBarHeight ? this.investmentElectricBarHeight : this.investmentHybridBarHeight}px + 100px)`,
        '--annual-div-height': `calc(${+this.annualCostElectricBarHeight > +this.annualCostHybridBarHeight ? this.annualCostElectricBarHeight : this.annualCostHybridBarHeight}px + 100px)`,
      };
    },
  },
  methods: {
    calculateForm() {
      const results = calculation(this.rheemPrice, this.validAvgEnergyRate, this.maxBarHeight);
      Object.assign(this.$data, results);
      if (this.paybackYears <= 0) {
        this.paybackYears = 'a year or less';
      }
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep .hwh-calculator__col{
  &--investment {
    min-height: var(--investment-div-height);
  }
  &--annual {
    min-height: var(--annual-div-height);
  }
}

@media(max-width: 991px) {
  ::v-deep .hwh-calculator__col.hwh-calculator__col{
    &--investment {
      height: var(--investment-div-height);
    }
    &--annual {
      height: var(--annual-div-height);
    }
  }
}
</style>
